import React from 'react';
import style from './style.module.scss';

export const PageColumn: React.FC = ({ children }) => {
  return <div className={style.pageColumn}>{children}</div>;
};

export default PageColumn;
